import React from 'react'
import { Outlet } from 'react-router-dom'
import CustomAppBar from '../../components/CustomAppbar'
import { Box, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const DashboardLayout: React.FC = (): JSX.Element => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTablet = useMediaQuery(theme.breakpoints.only('sm'))

  const calculateAppbarOffset = (): string => {
    switch (true) {
      case isMobile:
        return `${theme.spacing(16)}`
      case isTablet:
        return `${theme.spacing(18)}`
      default:
        return `${theme.spacing(20)}`
    }
  }

  return (
    <Box>
      <CustomAppBar />
      <Box
        px={{
          xs: `${theme.spacing(6)}`,
          sm: `${theme.spacing(13)}`
        }}
        paddingTop={calculateAppbarOffset()}
      >
        <Outlet />
      </Box>
    </Box>
  )
}

export default DashboardLayout
